import { useRef, useState, useEffect } from 'react'
import { Text, RenderTexture, PerspectiveCamera } from '@react-three/drei'

// Simple typing animation for "BREWING..." text
function BrewingAnimation({ fontSize = 1, color = '#35c19f' }) {
  const [displayText, setDisplayText] = useState('')
  const fullText = '\uEC15BREWING...'

  useEffect(() => {
    let currentIndex = 0
    let mounted = true

    const typeNextChar = () => {
      if (!mounted) return

      if (currentIndex <= fullText.length) {
        setDisplayText(fullText.slice(0, currentIndex))
        currentIndex++
        setTimeout(typeNextChar, 150)
      } else {
        // Restart after a pause
        setTimeout(() => {
          if (!mounted) return
          currentIndex = 0
          setDisplayText('')
          typeNextChar()
        }, 2000)
      }
    }

    typeNextChar()

    return () => {
      mounted = false
    }
  }, [])

  const hasIcon = displayText.startsWith('\uEC15')
  const iconPart = hasIcon ? displayText.slice(0, 1) : ''
  const textPart = hasIcon ? displayText.slice(1) : displayText
  const cursor = displayText.length < fullText.length ? '_' : ''

  return (
    <group>
      {hasIcon && (
        <Text
          font="/Gohu/GohuFont14NerdFontMono-Regular.ttf"
          position={[-1.6, 0, 0]}
          fontSize={fontSize * 1.2}
          color={color}
          anchorX="center"
          anchorY="middle"
        >
          {iconPart}
        </Text>
      )}
      <Text
        font="/Gohu/GohuFont14NerdFontMono-Regular.ttf"
        position={[hasIcon ? -0.9 : 0, 0, 0]}  // Moved closer to icon
        fontSize={fontSize}
        letterSpacing={0.05}
        color={color}
        anchorX={hasIcon ? 'left' : 'center'}
        anchorY="middle"
      >
        {textPart + cursor}
      </Text>
    </group>
  )
}

// Static brewing screen with neon effect - no bouncing, no interaction
export function StaticBrewingScreen({ position, rotation, scale = 0.8 }) {
  return (
    <group position={position} rotation={rotation} scale={scale}>
      {/* Static screen mesh - no animation */}
      <mesh>
        <planeGeometry args={[2, 1.33]} />
        <meshBasicMaterial toneMapped={false}>
          <RenderTexture width={512} height={384} attach="map" anisotropy={16}>
            <PerspectiveCamera makeDefault manual aspect={4/3} position={[0, 0, 10]} />
            {/* Dark background for neon effect */}
            <color attach="background" args={['black']} />
            <ambientLight intensity={0.5} />
            {/* Animated brewing text with neon green color */}
            <BrewingAnimation fontSize={1} color="#35c19f" />
            {/* Static "COFFEE CODED" text below */}
            <Text
              font="/Gohu/GohuFont14NerdFontMono-Regular.ttf"
              position={[0, 1.5, 0]}
              fontSize={0.8}
              letterSpacing={0.05}
              color="#35c19f"
              anchorX="center"
              anchorY="middle"
              material-transparent={true}
              material-opacity={0.7}
            >
              COFFEE CODED
            </Text>
          </RenderTexture>
        </meshBasicMaterial>
      </mesh>
    </group>
  )
}